import { Box, Alert, Link, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import './index.css'
import ZendeskLink from 'components/Common/ZendeskLink'
import { resendOTP, confirmSignUpEmail } from 'store/actions/authActions'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DISABLED_BUTTON, PRIMARY_BUTTON } from 'themes/theme'
import Button from 'components/Common/Button'

const OTPVerify = () => {
  const dispatch = useDispatch()
  const emailInfo = useSelector(state => state.authReducer)
  const [otpCode, setOTP] = useState()
  const [spinner, setSpinner] = useState(false)
  const [inValid, setInvalid] = useState(false)
  const [sendOtp, setOtp] = useState(false)
  const [showError, setShowError] = useState(false)
  const navigate = useNavigate()
  const handleSubmit = e => {
    e.preventDefault()
    confirmSignUpEmail(
      emailInfo,
      otpCode,
      (val, spinerStatus) => {
        setShowError(val)
        setSpinner(spinerStatus)
      },
      navigate,
      dispatch,
    )
  }
  const handleBlur = e => {
    const { value } = e.target
    if (!value) {
      setInvalid('This field is Required')
    } else {
      setInvalid(false)
    }
  }
  const handleResend = () => {
    resendOTP(emailInfo.email.toLowerCase(), val => setOtp(val))
  }
  return (
    <Box
      padding="30px"
      height="100%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      display="flex"
      color="#25245f"
    >
      <Box onSubmit={handleSubmit} width="370px" className="mt-3" component="form">
        <h4 style={{ marginTop: '20%', fontSize: '24px' }} className="authTitle">
          Enter your confirmation code
        </h4>
        <Box color="#25245f" className="mb-5" fontSize="16px">
          Your account is not activated yet. For security purposes, please check your email <b>{emailInfo.email}</b> to
          activate your account and get started with Markaaz.
        </Box>
        <Box className={`my-3 authForm ${inValid ? 'inValid' : ''}`}>
          <label htmlFor="userName" className="form-label required">
            Confirmation Code
          </label>
          <input
            onBlur={handleBlur}
            onChange={e => setOTP(e.target.value)}
            name="userName"
            type="text"
            className="form-control"
            id="userName"
          />
          <Box className="errorMessage mt-1" fontSize="12px" fontWeight={400} color="#D14343">
            {inValid}
          </Box>
        </Box>
        <Box className="my-5" color="#25245" fontSize="14px">
          Didn’t receive your code? Please refresh your email inbox, check spam and junk folders, or{' '}
          <Link onClick={handleResend} underline="hover" sx={{ cursor: 'pointer' }}>
            <Typography component="span" variant="body2B" color="secondary">
              {sendOtp ? 'Sending' : 'click here'}
            </Typography>
          </Link>{' '}
          to send a new confirmation code.
        </Box>
        {showError && (
          <Alert severity="error" role="alert" className="mt-2" onClose={() => setShowError(false)}>
            {showError}
          </Alert>
        )}
        <Box className="mt-5" textAlign="center">
          <Button
            disabled={!otpCode || inValid}
            type={!otpCode || inValid ? DISABLED_BUTTON : PRIMARY_BUTTON}
            sx={{ width: '250px' }}
            submit
            loading={spinner}
          >
            Submit
          </Button>
        </Box>
      </Box>
      <Box marginTop="auto">
        <ZendeskLink />
      </Box>
    </Box>
  )
}

export default OTPVerify
